import { AttributeDataType, AttributeValue } from '@msdyn365-commerce/retail-proxy';
import nbNO from './attribute-locale/nb-NO.json';
import enUS from './attribute-locale/en-US.json';

export interface IAttributeLocale {
    productDescription: string;
}

export type AttributeLocaleKeys = keyof IAttributeLocale;

function getAttributeKeys(locale: string): IAttributeLocale {
    // Import attribute-locale/nb-NO.json or attribute-locale/en-US.json dynamically based on the locale
    switch (locale) {
        case 'nb-NO':
            return { ...enUS, ...nbNO } as IAttributeLocale;
        case 'en-US':
        default:
            return { ...enUS } as IAttributeLocale;
    }
}

export function getAttributeValue(
    locale: string,
    attributeName: AttributeLocaleKeys,
    attributes: AttributeValue[] | undefined
): string | undefined {
    if (!attributes || attributes.length === 0) {
        return undefined;
    }

    const attributeKeys = getAttributeKeys(locale);
    // eslint-disable-next-line security/detect-object-injection
    const key = attributeKeys[attributeName];
    const attribute = attributes.find(attr => attr.Name === key);

    if (!attribute) {
        return undefined;
    }

    switch (attribute.DataTypeValue) {
        case AttributeDataType.Currency:
            return attribute.CurrencyValue ? attribute.CurrencyValue.toString() : undefined;
        case AttributeDataType.DateTime:
            return attribute.DateTimeOffsetValue ? attribute.DateTimeOffsetValue.toISOString() : undefined;
        case AttributeDataType.Decimal:
            return attribute.FloatValue ? attribute.FloatValue.toString() : undefined;
        case AttributeDataType.Integer:
            return attribute.IntegerValue ? attribute.IntegerValue.toString() : undefined;
        case AttributeDataType.Text:
            return attribute.TextValue ? attribute.TextValue : undefined;
        case AttributeDataType.TrueFalse:
            return attribute.BooleanValue !== undefined ? (attribute.BooleanValue ? 'true' : 'false') : undefined;
        default:
            return undefined;
    }
}
